import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { InputBox } from "../../components";
import { ApiHelper, BillableItemInterface, DateHelper } from "../../helpers";

interface Props {
  billableItem: BillableItemInterface,
  onClose: () => void
}

export const EditBillableItem: React.FC<Props> = props => {

  const [billableItem, setBillableItem] = React.useState<BillableItemInterface>(null);


  const init = () => {
    setBillableItem(props.billableItem);
  }

  React.useEffect(init, [props.billableItem])

  const handleSave = () => {
    ApiHelper.post("/billableItems", [billableItem]).then(() => { props.onClose() });
  }

  const updateValue = (id: string, val: string) => {
    let p: BillableItemInterface = { ...billableItem };
    switch (id) {
      case "startDate": p.startDate = DateHelper.convertToDate(val); break;
      case "monthlyRate": p.monthlyRate = parseFloat(val.replace("$", "").replace(",", "")); break;
    }
    setBillableItem(p);
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateValue(e.currentTarget.id, e.currentTarget.value)
  }

  const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  return (
    <>
      <InputBox headerText="Edit Subscription" headerIcon="fa fa-money" saveFunction={handleSave} cancelFunction={props.onClose} >
        <FormGroup>
          <FormLabel>Start Date</FormLabel>
          <FormControl id="startDate" value={DateHelper.formatHtml5Date(billableItem?.startDate || new Date())} onChange={handleChange} type="date" />
        </FormGroup>
        <FormGroup>
          <FormLabel>Monthly Rate</FormLabel>
          <FormControl id="monthlyRate" value={formatter.format(billableItem?.monthlyRate)} onChange={handleChange} />
        </FormGroup>
      </InputBox>
    </>
  );
};